import { render, staticRenderFns } from "./GetSentence.vue?vue&type=template&id=097256d8&scoped=true&"
import script from "./GetSentence.vue?vue&type=script&lang=js&"
export * from "./GetSentence.vue?vue&type=script&lang=js&"
import style0 from "./GetSentence.vue?vue&type=style&index=0&id=097256d8&lang=less&scoped=true&"
import style1 from "./GetSentence.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097256d8",
  null
  
)

export default component.exports